import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Grid,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';
import { GetApp as DownloadIcon } from '@mui/icons-material';
import MainLayout from '../../components/layout/MainLayout';
import axios from 'axios';

const ReportsList: React.FC = () => {
  const [reportType, setReportType] = useState('attendance');
  const [loading, setLoading] = useState(false);

  const handleGenerateReport = async () => {
    setLoading(true);
    try {
      let endpoint = '';
      switch (reportType) {
        case 'attendance':
          endpoint = '/reports/attendance';
          break;
        case 'fee':
          endpoint = '/reports/fee';
          break;
        case 'examination':
          endpoint = '/reports/examination';
          break;
        case 'students':
          endpoint = '/reports/students';
          break;
        default:
          return;
      }

      const response = await axios.get(endpoint);
      // In a real implementation, you'd download or display the report
      console.log('Report data:', response.data);
      alert('Report generated successfully. Check console for data.');
    } catch (error) {
      console.error('Failed to generate report:', error);
      alert('Failed to generate report');
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom>
          Reports
        </Typography>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Generate Report
              </Typography>
              <Box sx={{ mt: 2 }}>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Report Type</InputLabel>
                  <Select
                    value={reportType}
                    onChange={(e) => setReportType(e.target.value)}
                    label="Report Type"
                  >
                    <MenuItem value="attendance">Attendance Report</MenuItem>
                    <MenuItem value="fee">Fee Report</MenuItem>
                    <MenuItem value="examination">Examination Report</MenuItem>
                    <MenuItem value="students">Student Report</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  startIcon={<DownloadIcon />}
                  onClick={handleGenerateReport}
                  disabled={loading}
                  fullWidth
                >
                  Generate Report
                </Button>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Available Reports
              </Typography>
              <Box component="ul" sx={{ mt: 2 }}>
                <li>Attendance Report - View attendance records by date range and class</li>
                <li>Fee Report - View fee transactions and collections</li>
                <li>Examination Report - View examination results and grades</li>
                <li>Student Report - View student information and statistics</li>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </MainLayout>
  );
};

export default ReportsList;



